<template>
  <b-form
    autocomplete="off"
    @submit.prevent="filterUser"
  >
    <b-row class="mb-2">
      <b-col cols="3">
        <b-form-group>
          <b-input-group class="input-group-merge">
            <b-form-input
              id="name"
              v-model="form.params.name"
              :placeholder="t('Name')"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group>
          <b-input-group class="input-group-merge">
            <b-form-input
              id="email"
              v-model="form.params.email"
              :placeholder="t('Email')"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group>
          <b-input-group class="input-group-merge">
            <b-form-input
              id="owner-name"
              v-model="form.params.owner_name"
              :placeholder="t('Owner Name')"
            />
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col cols="3">
        <b-form-group>
          <b-input-group class="input-group-merge">
            <vue-autosuggest
              ref="city_name"
              v-model="city_name"
              :suggestions="cityOptions"
              :input-props="{id: 'autosuggest__input_ajax',
                             placeholder: t('City'),
                             class: 'form-control',}"
              :render-suggestion="renderSuggestion"
              :get-suggestion-value="renderSuggestion"
              @selected="change_autosuggest"
              @input="suggestForm"
            />
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col
        cols="12"
        class="text-center"
      >
        <b-button
          variant="success mx-1"
          type="submit"
        >
          {{ t('Search') }}
        </b-button>
        <b-button
          variant="danger mx-1"
          @click="resetCompanyFilter"
        >
          {{ t('Reset') }}
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { VueAutosuggest } from 'vue-autosuggest'
import { useUtils } from '@core/libs/i18n'
import {
  BRow, BCol, BInputGroup, BFormGroup, BButton, BForm, BFormInput,
} from 'bootstrap-vue'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '../../../store'
import { status } from '../../../utils/common'

export default {
  components: {
    BForm,
    BFormInput,
    BRow,
    BCol,
    VueAutosuggest,
    BInputGroup,
    BFormGroup,
    BButton,
    // BCollapse,
  },
  props: ['filter'],
  setup() {
    const { t } = useUtils()
    return { t }
  },
  data() {
    return {
      cityOptions: [],
      userTypeOptions: [],
      city_name: '',
      status,
      form: {
        params: {
          owner_name: '',
          city: '',
          email: '',
          name: '',
        },
        size: 10,
        totalElements: '',
        totalPages: '',
        sortBy: 'company_id',
        sortOrder: 'desc',
      },
    }
  },
  watch: {
    filter: {
      deep: true,
      handler(newVal) {
        this.form = newVal
      },
    },
  },
  mounted() {
    store.dispatch('userManage/getUserType').then(response => {
      if (response.data.code === '200') {
        this.userTypeOptions = response.data.data
      }
    })
  },
  methods: {
    SearchLeadData() {
      this.$emit('searchData', this.form)
    },
    suggestForm(val) {
      if (val.length >= 3) {
        store.dispatch('getCountryList/getCityAuto', { city: val }).then(response => {
          if (response.data.code === '200') {
            this.cityOptions.splice(0, this.cityOptions.length)
            this.cityOptions.push({ data: response.data.data })
            this.selected = null
          }
        })
      }
    },
    resetCompanyFilter() {
      this.form = {
        params: {
          owner_name: '',
          city: '',
          email: '',
          name: '',
        },
        size: '',
        totalElements: '',
        totalPages: '',
        sortBy: '',
        sortOrder: '',
      }
      this.city_name = ''
    },
    filterUser() {
      this.$emit('searchData', this.form)
    },
    change_autosuggest(val) {
      this.form.params.city = val.item.location_id
      this.city_name = val.item.city
      this.$emit('getCreateUser', this.form)
    },
    renderSuggestion(suggestion) {
      return suggestion.item.city
    },
  },

}
</script>

<style>
</style>
